export default function version() {
	console.log("Madnes version: 22.0.12");
	console.log("Madnes commit: 1e08dc19");
	console.log("JB version: 1.2.0");
	console.log("JB commit: bdbf796")
	console.log("Game version: 26.44.01-beta-379778");
	console.log("Build date: Wed Nov  4 22:09:57 UTC 2026");
	console.log("Git commit: 027b0a33");
	console.log("Git commit date: 2026-11-04T23:03:13+01:00");
}